import { Navigate, useLocation } from 'react-router-dom';
import { BYPASS_AUTH } from '../utils/ip';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const accessToken = localStorage.getItem('accessToken');
  
  const bypassAuth = BYPASS_AUTH === 'true';
  
  if (bypassAuth) {
    return children;
  }

  // Check if accessToken exists and is not empty/null
  if (!accessToken || accessToken === 'null' || accessToken === 'undefined' || accessToken.trim() === '') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;